import React from 'react';
import { Link } from 'react-router-dom';

const SIZES = { sm: 'w-7 h-7', md: 'w-9 h-9', lg: 'w-11 h-11', xl: 'w-12 h-12' };

// Avatar + name (+ optional role) for article bylines. When `link` is set,
// the byline links to all stories by that author.
const AuthorBadge = ({ author, size = 'md', showRole = true, link = false }) => {
  const content = (
    <div className="flex items-center gap-3">
      <img
        src={author.avatar}
        alt={author.name}
        className={`${SIZES[size]} rounded-full object-cover object-top border border-white/10 ${link ? 'transition-transform group-hover:scale-105' : ''}`}
      />
      <div className="leading-tight">
        <p className={`text-white text-sm font-medium ${link ? 'transition-colors group-hover:text-[#e8743b]' : ''}`}>{author.name}</p>
        {showRole && <p className="text-[#6b7384] text-xs">{author.role}</p>}
      </div>
    </div>
  );

  if (!link) return content;

  return (
    <Link
      to={`/news?author=${encodeURIComponent(author.name)}`}
      data-testid="author-stories-link"
      title={`See all stories by ${author.name}`}
      className="group inline-flex"
    >
      {content}
    </Link>
  );
};

export default AuthorBadge;
